import { Modal, UploadFile } from 'antd';
import React, { useState } from 'react';
import { FileType, getBase64 } from '../lib/utils';

interface FilePreviewModalProps {
  visible: boolean;
  onCancel: () => void;
  file: UploadFile;
}

const FilePreviewModal: React.FC<FilePreviewModalProps> = ({
  visible,
  onCancel,
  file,
}) => {
  const [previewTitle, setPreviewTitle] = useState<string>('');

  const handlePreview = async () => {
    if (!file.url && !file.preview) {
      // Assume getBase64 is your function to convert file to base64
      file.preview = await getBase64(file.originFileObj as FileType);
    }
    setPreviewTitle(file.name || '');
  };

  return (
    <Modal
      open={visible}
      title={previewTitle}
      footer={null}
      onCancel={onCancel}
      onOk={handlePreview}
    >
      <img alt={previewTitle} className={'w-auto h-auto'} src={file?.url} />
    </Modal>
  );
};

export default FilePreviewModal;
